export const tagId = location.origin === 'https://apps.gunify.vonage.com' ? 'UA-91637642-6' : 'UA-91637642-7';
export const gtag: any = function () {
  if ((window as any).dataLayer instanceof Array) {
    (window as any).dataLayer.push(arguments);
  }
}